import { __assign, __rest } from "tslib";
import React from 'react';
import SlickCarousel from 'react-slick';
import classnames from 'classnames';
import { LeftIcon, RightIcon } from '../icons';
import { usePrefix } from '../ConfigProvider';
import { concat } from '../utils';
export default function Carousel(props) {
    var _a = props.size, size = _a === void 0 ? 'default' : _a, _b = props.type, type = _b === void 0 ? 'default' : _b, _c = props.autoplay, autoplay = _c === void 0 ? false : _c, _d = props.autoplaySpeed, autoplaySpeed = _d === void 0 ? 2000 : _d, beforeChange = props.beforeChange, afterChange = props.afterChange, children = props.children, rootHtmlProps = props.rootHtmlProps;
    var prefix = usePrefix('carousel');
    var typePrefix = concat(prefix, type);
    var sizePrefix = concat(typePrefix, size);
    var className = classnames(prefix, typePrefix, sizePrefix, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var dotsClass = classnames('slick-dots slick-dots-bottom', typePrefix, sizePrefix);
    var newProps = {
        arrows: false,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        cssEase: 'linear',
        infinite: true,
        speed: 300,
        draggable: false,
        dotsClass: dotsClass,
        beforeChange: beforeChange,
        afterChange: afterChange,
        nextArrow: React.createElement(SlickArrow, { className: sizePrefix },
            React.createElement(RightIcon, null)),
        prevArrow: React.createElement(SlickArrow, { className: sizePrefix },
            React.createElement(LeftIcon, null))
    };
    if (type === 'secondary') {
        newProps.arrows = true;
    }
    return (React.createElement("div", __assign({}, rootHtmlProps, { className: className }),
        React.createElement(SlickCarousel, __assign({ arrows: false, dots: true }, newProps), children)));
}
// 去掉多余的属性，不然控制台有 warning
function SlickArrow(_a) {
    var currentSlide = _a.currentSlide, slideCount = _a.slideCount, children = _a.children, style = _a.style, props = __rest(_a, ["currentSlide", "slideCount", "children", "style"]);
    var centerStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center' };
    return React.createElement("div", __assign({ style: __assign(__assign({}, style), centerStyle) }, props), children);
}
//# sourceMappingURL=index.js.map